const HomeTypeEnum = {
  Single: { value: 'Single Family Home', name: 'Single Family Home' },
  Condo: { value: 'Condo', name: 'Condo' },
  Mobile: { value: 'Mobile Home', name: 'Mobile Home (Confirm Land Ownership)' },
  Manufactured: { value: 'Manufactured Home', name: 'Manufactured Home (Confirm Land Ownership)' },
};

export default HomeTypeEnum;
